<div class="breadcrumbs">
    <div>/</div>
    <div>Governance</div>
    <div>/</div>
    <div class="hasLink" [routerLink]="['/data-catalogue']">Data Catalogues</div>
    <div>/</div>
    <div>Facilis Origin AIXM 5.1</div>
    <div>/</div>
    <div>Group: {{ propertyGroupName }}</div>
</div>
<mat-toolbar>
  <span>
    <h3>Group: {{ propertyGroupName }}</h3>
  </span>
</mat-toolbar>

<mat-expansion-panel class="custom-panel">
    <mat-expansion-panel-header>
        <mat-panel-title><b>Metadata</b> </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="metadata-content">
        <div class="metadata-item">
            <div class="metadata-key">Identifier:</div>
            <div class="metadata-value">{{ propertyGroupName }}</div>
        </div>
        <div class="metadata-item">
            <div class="metadata-key">Catalogue item type:</div>
            <div class="metadata-value">Property group</div>
        </div>
        <div class="metadata-item">
            <div class="metadata-key"><b>Display name:</b></div>
        </div>
        <form [formGroup]="form">
            <div formArrayName="displayName">
                <div class="metadata-detailed-item" *ngFor="let group of displayNameArray.controls; let i = index" [formGroupName]="i">
                    <div class="metadata-detail-key">{{ getLanguageName(metaData.displayName[i].lang) }}</div>
                    <mat-form-field appearance="outline" class="full-width">
                        <input
                            matInput
                            placeholder=""
                            name="displayName"
                            formControlName="text"
                        />
                    </mat-form-field>
                </div>
            </div>

            <div class="metadata-item">
                <div class="metadata-key"><b>Description:</b></div>
            </div>

            <div formArrayName="description">
                <div class="metadata-detailed-item" *ngFor="let group of descriptionArray.controls; let i = index" [formGroupName]="i">
                    <div class="metadata-detail-key">{{ getLanguageName(metaData.description[i].lang) }}</div>
                    <div class="metadata-deatil-value full-width-input">
                        <mat-form-field appearance="outline" class="full-width">
                          <textarea
                              matInput
                              placeholder=""
                              name="description"
                              rows="4"
                              formControlName="text"
                              disabled
                          ></textarea>
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </form>

        <div class="metadata-item">
            <div class="metadata-key">Last edited by:</div>
            <div class="metadata-value">{{this?.metaData?.author}}</div>
        </div>
        <div class="metadata-item">
            <div class="metadata-key">Last edited on:</div>
            <div class="metadata-value">{{ this?.metaData?.timestamp}}</div>
        </div>
    </div>
</mat-expansion-panel>

<div class="content-container">
    <div class="tree-container">
        <mat-tree
            #tree
            [dataSource]="dataSource"
            [treeControl]="treeControl"
        >
            <mat-nested-tree-node
                *matTreeNodeDef="let node; when: hasChild"
                matTreeNodePadding
                matTreeNodeToggle
                class="customTreeNode"
                [class.isChoiceType]="node?.type === 'choice'"
            >
                <button
                    mat-icon-button
                    matTreeNodeToggle
                    [attr.aria-label]="'Toggle ' + node.name"
                    [disabled]="!treeControl.getChildren(node)?.length"
                    class="treeNodeCustomButton"
                >
                    <mat-icon>
                        {{ !treeControl.getChildren(node)?.length ? "data_object" : treeControl.isExpanded(node) ? "expand_more" : "chevron_right" }}
                    </mat-icon>
                </button>
                <span
                    *ngIf="node?.type !== 'choice'"
                    class="treeNodeCustomLabel"
                    [routerLink]="node?.type === 'groups' ?
                    (node?.root ? undefined : ['/data-catalogue/' + catId + '/property-group/' + node?.name])
                    :
                    ['/data-catalogue/' + catId + '/property/' + node?.propertyId]"
                >
                    <span *ngIf="node?.type === 'groups'"><b>Group: </b></span>
                    <span [innerHTML]="node.name"></span>
                </span>
                <span
                        *ngIf="node?.type === 'choice'"
                        class="treeChoiceContainer"
                >
              <span *ngFor="let option of node?.options">
                <span
                  class="treeNodeCustomLabel"
                  [routerLink]="'/data-catalogue/' + catId + '/property/' + option?.propertyId"
                  *ngIf="!option?.options"
                >
                  {{ option?.name }}
                </span>
                <span
                  *ngIf="option?.options"
                  class="treeSubChoiceContainer"
                >
                  <span *ngFor="let subOption of option?.options">
                    <span
                      class="treeNodeCustomLabel"
                      *ngIf="!subOption?.options"
                      [routerLink]="'/data-catalogue/' + catId + '/property/' + subOption?.propertyId"
                    >
                      {{ subOption?.name }}
                    </span>
                  </span>
                </span>
                <br />
              </span>
          </span>
                <br />
                <div [class.tree-invisible]="!treeControl.isExpanded(node)">
                    <ng-container matTreeNodeOutlet></ng-container>
                </div>
            </mat-nested-tree-node>
        </mat-tree>
    </div>
    <!-- <div class="feature-info-container">
        <div class="info-title">
            <div class="official-data">Official Data</div>
            <div class="smaller">(effective 1 FEB 2025)</div>
        </div>
        <div class="occuriencies">Occurencies: 26</div>
    </div> -->
</div>